module.exports = __webpack_public_path__ + "static/media/calendar_icon_selected.f76978bc.svg";